import { render, staticRenderFns } from "./transaction_types.vue?vue&type=template&id=183874e2"
import script from "./transaction_types.js?vue&type=script&lang=js&external"
export * from "./transaction_types.js?vue&type=script&lang=js&external"
import style0 from "./transaction_types.vue?vue&type=style&index=0&id=183874e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports